import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth.jsx";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        await exchangeGoogle(sessionId);
        toast.success("Signed in with Google");
        // Strip the hash and go to dashboard
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google login failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeGoogle, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-slate-500 text-sm">Completing sign-in…</div>
    </div>
  );
}
